import React from "react";
import { Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getAppColor, getAvatar } from "@icarius-app/selectors";
import ProfileImg from "@icarius-common/profileImg";
import IcariusIcon from "@icarius-assets/images/icariusIcon.png";
import { getLocalizedString } from "@icarius-localization/strings";
import DotsLoading from "./dotsLoading";
import AttachmentsDisplay from "./attachmentsDisplay";
import Text from "./text";

const getBubbleRadius = (isUser) => (isUser ? "10px 1px 10px 10px" : "1px 10px 10px 10px");

const Message = (props) => {
    const { text, status, attachments, time, isUser } = props;

    const color = useSelector(getAppColor);
    const avatar = useSelector(getAvatar);

    const avatarElement = <ProfileImg size={24} image={isUser ? avatar : IcariusIcon} external={!isUser} />;

    return (
        <div
            style={{
                maxWidth: "85%",
                alignSelf: isUser ? "flex-end" : "flex-start",
                display: "flex",
                gap: 8,
            }}
        >
            {!isUser && avatarElement}
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "fit-content",
                    padding: "5px 10px",
                    borderRadius: getBubbleRadius(isUser),
                    background: isUser ? color : "var(--secondaryBackgroundColor)",
                    color: isUser ? "white" : "var(--mainText)",
                    overflow: "auto",
                }}
            >
                {!isUser && (
                    <Typography className={"whiteText"} variant="caption" style={{ fontWeight: 600 }}>
                        {getLocalizedString("icariusAssistant")}
                    </Typography>
                )}
                {!text && !attachments && <DotsLoading />}
                {
                    <>
                        <Text text={text} status={status} />
                        <AttachmentsDisplay attachments={attachments} isUser={isUser} />
                        {time && (
                            <Typography color="inherit" style={{ fontSize: 10, textAlign: isUser ? "right" : "left" }}>
                                {time}
                            </Typography>
                        )}
                    </>
                }
            </div>
            {isUser && avatarElement}
        </div>
    );
};

export default Message;
